import React, { useState, useEffect } from "react";
import { Table } from "antd";
import Api from "../../services/ServiceApi";
import { FormatDateTime } from "../utility/format";
import { BadgePill } from "../badge_pill/badge_pill";
export default function ApproveProcessLog({ sendData, header }) {
  const { approve_id } = sendData;
  const column = [
    {
      title: null,
      dataIndex: "",
      key: "",
      ellipsis: {
        showTitle: false,
      },
      width: 100,
      render: (item) => (
        <BadgePill
          bgColor={item.backgroundColor}
          color={item.color}
          text={`${item.status} Level: ${item.approve_level_seq}`}
        ></BadgePill>
      ),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      width: 160,
    },
    {
      title: "Action By",
      dataIndex: "emp_name",
      key: "emp_name",
      width: 150,
    },
    {
      title: "Action Date",
      dataIndex: "date",
      key: "date",
      width: 120,
      render: (s) => <FormatDateTime text={s} format="dmyHm"></FormatDateTime>,
    },
    {
      title: "Remark",
      dataIndex: "remark",
      key: "remark",
      // width: 180,
    },
  ];
  const [listLog, setlistLog] = useState([]);
  useEffect(() => {
    Api.post("Approve/get_approve_process_log", {
      approve_id: approve_id,
    }).then((res) => {
      const { result, data } = res.data;
      if (result.code === "P") {
        const logFilter = data.approve_process_log.map((s) => ({
          status: s.approve_status_name,
          statusid: s.approve_status_id,
          date: s.approve_date,
          reason: s.service_ma_reason_desc,
          emp_name: s.emp_name,
          remark: s.status_remark,
          approve_level_seq: s.approve_level_seq,
          backgroundColor: s.approve_status_bgcolor,
          color: s.approve_status_color,
        }));
        setlistLog(logFilter);
      }
    });
  }, []);
  return (
    <>
      <div className="mb-2 card">
        <div className="card-body ">
          {header ? <h5 className="card-title">{header}</h5> : null}
          <Table
            pagination={false}
            // scroll={{ y: 300, x: "max-content" }}
            scroll={{ y: 300, x: 1000 }}
            tableLayout="fixed"
            columns={column}
            dataSource={listLog}
          />
        </div>
      </div>
    </>
  );
}
